import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { getPlatforms } from '../utils';

export default function OfferCard({
  id,
  title,
  requirements,
  description,
  pointsName,
  pointsValue,
  deviceTypes,
  subtasksCompleted = 0,
  totalSubtasks,
  iconUrl,
  onShow,
  dataTestId = 'offer-card',
}) {
  const { getText } = Pollfish.ui;
  const updatedPlatforms = getPlatforms(deviceTypes);
  const isRtlEnabled =
    document.querySelector('html').getAttribute('dir') === 'rtl';

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className="margin-sm-btm col-6 media-small-screen-full-width js-offer-card"
      onClick={() => onShow(id)}
      data-testid={dataTestId}
      data-ow-sdk-offer-id={id}
    >
      <article className="card-v2">
        <section className="card-v2-body">
          <header className="margin-sm-btm offerwall-offers-card-title">
            {!isRtlEnabled && (
              <Fragment>
                <span className="font-bold" data-testid="offer-card-title">
                  {title}
                </span>
                {requirements && (
                  <Fragment>
                    <span className="margin-xxs-horizontal font-bold">
                      &middot;
                    </span>
                    <span className="text-sm">
                      <i>{requirements}</i>
                    </span>
                  </Fragment>
                )}
              </Fragment>
            )}
            {isRtlEnabled && (
              <Fragment>
                {requirements && (
                  <Fragment>
                    <span className="text-sm">
                      <i>{requirements}</i>
                    </span>
                    <span className="margin-xxs-horizontal font-bold">
                      &middot;
                    </span>
                  </Fragment>
                )}
                <span className="font-bold" data-testid="offer-card-title">
                  {title}
                </span>
              </Fragment>
            )}
          </header>
          <div className="flex">
            {iconUrl && (
              <img
                className="margin-xs-right offerwall-offers-card-icon"
                src={iconUrl}
                alt={title}
              />
            )}
            <div className="flex-1" style={{ width: 'calc(100% - 104px)' }}>
              <h1
                className="text-xxl font-bold margin-reset line-height-reset js-offer-points"
                data-offer-id={id}
              >
                {pointsValue}
              </h1>
              <p
                className="margin-reset margin-sm-btm"
                data-testid="offer-reward-currency"
              >
                {pointsName}
              </p>
              <span
                className="text-grey-light"
                style={{
                  display: 'block',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {description}
              </span>
            </div>
          </div>
        </section>
        <footer className="card-v2-footer text-sm">
          <div className="divider margin-md-btm"></div>
          <div className="flex flex-wrap offerwall-offers-card-footnote">
            {updatedPlatforms.map((platform) => (
              <Fragment key={platform.key}>
                {platform.icon}
                <span className="margin-xxs-horizontal text-grey-light font-bold">
                  &middot;
                </span>
              </Fragment>
            ))}
            <span className="text-grey-light">
              {getText('offerwall.offers.activities')}:
            </span>
            <span className="font-bold margin-xxs-left offer-rtl-text-xxs">
              {subtasksCompleted}/{totalSubtasks}
            </span>
            <span className="margin-xxs-horizontal text-grey-light font-bold">
              &middot;
            </span>
            <span className="text-grey-light">{pointsName}:</span>
            <span className="font-bold margin-xxs-left offer-rtl-text-xxs">
              0/{pointsValue}
            </span>
          </div>
        </footer>
      </article>
    </div>
  );
}

OfferCard.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  requirements: PropTypes.string,
  description: PropTypes.string,
  pointsName: PropTypes.string,
  pointsValue: PropTypes.number,
  deviceTypes: PropTypes.any,
  subtasksCompleted: PropTypes.number,
  totalSubtasks: PropTypes.number,
  iconUrl: PropTypes.string,
  onShow: PropTypes.func,
  dataTestId: PropTypes.string,
};
